import { render } from "./main.vue?vue&type=template&id=0bd0e088"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Haniel\\Desktop\\PROJECTS\\TANOU-ACADEMY\\e-commerce-webadmin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_2cebe3dcb9a4454fa15f9df2c44405de\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__